import arrowIosBackFill from '@iconify/icons-eva/arrow-ios-back-fill';
import { Icon } from '@iconify/react';
import { Box, Button, Card, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import resetPasswordIllustration from 'assets/reset_password_illustration.svg';
import MHidden from 'components/@material-extend/MHidden/MHidden';
import ResetPasswordRequestForm from 'components/auth/ResetPassword/ResetPasswordRequestFrom';
import Page from 'components/Page/Page';
import useLocales from 'hooks/useLocales';
import AuthLayout from 'layouts/AuthLayout';
import { PATH_AUTH } from 'routes/paths';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        display: 'flex',
    },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
    width: '100%',
    maxWidth: 464,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: theme.spacing(2, 0, 2, 2),
}));

const ContentStyle = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

const ResetPassword: React.FunctionComponent = () => {
    const { translate } = useLocales();

    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(false);

    return (
        <RootStyle title={`${translate('reset_password')} | CodeAcademy Kids`}>
            <AuthLayout />

            <MHidden width='mdDown'>
                <SectionStyle>
                    <img src={resetPasswordIllustration} alt={translate('reset_password_illustration')} />
                </SectionStyle>
            </MHidden>

            <Container>
                <ContentStyle>
                    <Box sx={{ maxWidth: 480, mx: 'auto' }}>
                        <Button
                            size='small'
                            component={RouterLink}
                            to={PATH_AUTH.login}
                            startIcon={<Icon icon={arrowIosBackFill} width={20} height={20} />}
                            sx={{ mb: 3, textTransform: 'capitalize' }}
                        >
                            {translate('back')}
                        </Button>
                        {!sent ? (
                            <>
                                <Typography variant='h3' paragraph>
                                    {translate('forgot_your_password_title')}
                                </Typography>
                                <Typography sx={{ color: 'text.secondary', mb: 5 }}>
                                    {translate('forgot_your_password_details')}
                                </Typography>

                                <ResetPasswordRequestForm
                                    onSent={() => setSent(true)}
                                    onGetEmail={value => setEmail(value)}
                                />
                            </>
                        ) : (
                            <Box sx={{ textAlign: 'center' }}>
                                <Typography variant='h3' gutterBottom>
                                    {translate('confirm_email')}
                                </Typography>
                                <Typography>
                                    {translate('sent_confirmation_email_to')} &nbsp;
                                    <strong>{email}</strong>
                                    <br />
                                    {translate('please_check_your_email')}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </ContentStyle>
            </Container>
        </RootStyle>
    );
};

export default ResetPassword;
